import { Typography } from "@codat/orchard-ui";
import React from "react";

import PromptSuggestion from "./PromptSuggestion";
import styles from "./WelcomeScreen.module.scss";

interface WelcomeScreenProps {
  onPromptClick: (text: string) => void;
}

const suggestedPrompts = new Set([
  "Who are the top 10 suppliers by payment volume?",
  "Which suppliers are most likely to convert spend to virtual card?",
]);

const WelcomeScreen = ({ onPromptClick }: WelcomeScreenProps) => (
  <div className={styles.welcome} data-testid="welcome-screen">
    <div>
      <Typography as="h2" variant="heading_xxl">
        What can we help you with?
      </Typography>
      <div className={styles.suggestions}>
        {[...suggestedPrompts].map((text) => (
          <PromptSuggestion key={text} text={text} onClick={onPromptClick} />
        ))}
      </div>
    </div>
  </div>
);

export default WelcomeScreen;
